export class CreateModuleReqVM {

    moduleID: number;
    moduleName: string;
    moduleRoute: string;
    isActive: boolean;
    createdBy: Date;
    modifiedBy: Date;
    officeID:number;

}
